module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-emails-collection">\n    <div class="b-emails-collection__content">\n        <span class="b-emails-collection__add b-emails-collection__add--color-gray"></span>\n    </div>\n</div>\n';

}
return __p
}